import React from "react";
import { Container, LinearLine } from "../styles/porfolio";
import Projects from "../components/projectTab";
import { NameCon, WindowBlack } from "../styles/home";

const Portfolio = () => {
  return (
    <WindowBlack>
      <Container>
        <LinearLine></LinearLine>
        <NameCon style={{ marginInline: "auto" }}>
          <p style={{ fontWeight: "bold" }}>Works & Projects</p>
        </NameCon>
        <p
          style={{
            fontSize: "clamp(1rem, 3.5vw, 40px)",
            fontWeight: "bold",
          }}
        >
          Crafting interactive and creative solutions
        </p>
        <Projects />
      </Container>
    </WindowBlack>
  );
};

export default Portfolio;
